/**
 * Spec 038: label formatters for the chart. Pure; handed to the library as
 * `tickMarkFormatter`, `localization.timeFormatter` and `priceFormat`.
 */

const pad = (n: number): string => String(n).padStart(2, '0')

/** UTC `MM-DD HH:MM`. */
export function formatAxisTime(sec: number): string {
  const d = new Date(sec * 1000)
  return `${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`
}

/** Price label with exactly `digits` decimals (the old `toFixed(digits)`). */
export function formatPrice(value: number, digits: number): string {
  return value.toFixed(Math.max(0, digits))
}

/** The library's built-in price format for `digits` decimals: `minMove = 10 ** -digits`. */
export function priceFormat(digits: number): { type: 'price'; precision: number; minMove: number } {
  const d = Math.max(0, Math.round(digits))
  return { type: 'price', precision: d, minMove: 10 ** -d }
}

/** Equity labels: rounded, en-US grouping, no decimals (the old equity axis). */
export function formatEquity(value: number): string {
  return Math.round(value).toLocaleString('en-US')
}

/**
 * The chart's text font. Kept in this library-free module so components in
 * the entry bundle (the equity-only chart's label) can use it without pulling
 * `lightweight-charts` out of its lazy chunk; `options.ts` re-exports both.
 */
export const CHART_FONT_FAMILY = 'ui-monospace, Menlo, monospace'
export const CHART_FONT_SIZE = 10
